import { Link } from "react-router-dom";
import { ReactSVG } from "react-svg";

const BuyPlansSupportBtn = () => {
  return (
    <Link
      to={`/messages/192/09335413742`}
      className="btn bg-primary w-fit md:mx-0 mx-auto font-medium gap-2"
    >
      <ReactSVG
        src={`${process.env.PUBLIC_URL}/assets/images/icons/support.svg`}
        className="w-6 translate-y-0.5"
      />
      پشتیبانی
    </Link>
  );
};

export default BuyPlansSupportBtn;
